"use strict";

var LoggerInstance = require("js-logger").get("AccountApi");

var AbstractApi = require("./AbstractApi");

var SavedPaymentsApi = class extends AbstractApi {
	addSavedPaymentToAccount(savedPaymentData) {
		return this.post({
			data: savedPaymentData,
			url: "/api/accountAddSavedPayment",
			reCAPTCHA: true
		});
	}

	deleteSavedPayment(savedPaymentId) {
		return this.delete({
			url: `/api/savedpayments/${savedPaymentId}`
		});
	}

	createHostedPageTokenFromSavedPayment(savedPaymentId) {
		return this.post({
			url: `/api/savedpayments/${savedPaymentId}/hostedpagetoken`
		});
	}

	updateSavedPayment(savedPaymentId, isPrimary) {
		return this.post({
			data: { isPrimary },
			url: `/api/accountUpdateSavedPayment/${savedPaymentId}`
		});
	}
};

module.exports = new SavedPaymentsApi();
